export type TargetSectionCode = 'Marketing' | 'TechnicalData' | 'Downloads' | 'Other'

export const TARGET_SECTION_OPTIONS: Array<{ code: TargetSectionCode; label: string }> = [
  { code: 'Marketing', label: 'Marketing' },
  { code: 'TechnicalData', label: 'Technical Data' },
  { code: 'Downloads', label: 'Downloads & Certificates' },
  { code: 'Other', label: 'Other' },
]

export function normalizeTargetSection(value?: string | null): TargetSectionCode {
  const trimmed = (value ?? '').trim().toLowerCase()
  switch (trimmed) {
    case '':
    case 'marketing':
    case 'productpage':
    case 'product page':
    case 'product_page':
      return 'Marketing'
    case 'technicaldata':
    case 'technical data':
    case 'technical_data':
    case 'technical':
    case 'datasheet':
      return 'TechnicalData'
    case 'downloads':
    case 'downloads & certificates':
    case 'downloadsandcertificates':
    case 'certificate':
    case 'certificates':
    case 'brochure':
      return 'Downloads'
    case 'other':
      return 'Other'
    default:
      if (TARGET_SECTION_OPTIONS.some((option) => option.code.toLowerCase() === trimmed)) {
        return TARGET_SECTION_OPTIONS.find((option) => option.code.toLowerCase() === trimmed)!.code
      }
      return 'Marketing'
  }
}

export function parseTargetSections(value?: string | null): TargetSectionCode[] {
  const parts = (value ?? '').split(/[,;|]/).map((part) => part.trim()).filter(Boolean)
  if (parts.length === 0) return ['Marketing']
  const codes: TargetSectionCode[] = []
  for (const part of parts) {
    const code = normalizeTargetSection(part)
    if (!codes.includes(code)) codes.push(code)
  }
  return codes
}

export function targetSectionLabel(value?: string | null): string {
  return parseTargetSections(value)
    .map((code) => TARGET_SECTION_OPTIONS.find((option) => option.code === code)?.label ?? 'Marketing')
    .join(', ')
}

export function targetMatchesSection(value: string | null | undefined, section: TargetSectionCode): boolean {
  return parseTargetSections(value).includes(section)
}

export function targetSectionFilterLabel(code: TargetSectionCode | 'All'): string {
  if (code === 'All') return 'All'
  return targetSectionLabel(code)
}

export const TARGET_SECTION_FILTER_CHIPS: Array<TargetSectionCode | 'All'> = [
  'All',
  'Marketing',
  'TechnicalData',
  'Downloads',
]
